<template>
  <div>
    <b-container v-if="!_.isEmpty(rate)">
      <b-row align-v="center" class="pb-4">
        <b-col lg="12">
          <template v-if="realUtilityType == 'Gas'">
            <h2 class="h3-semibold-black">Ecco l’offerta Serena Gas perfetta per te!</h2>
            <p class="p-medium-gray-600 mb-2">
              La rata è calcolata sul <span class="p-medium-azure">Tuo consumo GAS dell'ultimo anno, cioè <b>{{ numberFormat(rate.Gas.Consumption) }} Smc</b>.</span>
              Nella rata sono compresi, oltre alla spesa per la materia prima, la spesa per il trasporto e la gestione del contatore, gli oneri di sistema, i costi fissi le tasse e l'iva.</p>
          </template>
          <template v-else-if="realUtilityType == 'Electricity'">
            <h2 class="h3-semibold-black">Ecco l’offerta Serena Luce perfetta per te!</h2>
            <p class="p-medium-gray-600 mb-2">
              La rata è calcolata sul <span class="p-medium-azure">Tuo consumo LUCE dell'ultimo anno, cioè <b>{{ numberFormat(rate.Electricity.Consumption) }} kWh</b>.</span>
              Nella rata sono compresi, oltre alla spesa per la materia prima, la spesa per il trasporto e la gestione del contatore, gli oneri di sistema, i costi fissi le tasse e l'iva.</p>
          </template>
          <template v-else-if="realUtilityType == 'Dual'">
            <h2 class="h3-semibold-black">Ecco l’offerta Serena perfetta per te!</h2>
            <p class="p-medium-gray-600 mb-2">
              La rata è calcolata sul <span class="p-medium-azure">Tuo consumo LUCE + GAS dell'ultimo anno, cioè <b>{{ numberFormat(rate.Electricity.Consumption)  }} kWh</b> e <b>{{ numberFormat(rate.Gas.Consumption) }} Smc</b>.</span>
              Nella rata sono compresi, oltre alla spesa per la materia prima, la spesa per il trasporto e la gestione del contatore, gli oneri di sistema, i costi fissi le tasse e l'iva.</p>
          </template>
        </b-col>

        <b-col lg="6" class="lg:pr-6">

            <div class="box-rata mb-4" v-for="(r, k) in rate" :key="k">
              <div class="h3-regular-white text-center">La tua rata <b>Serena</b></div>
              <div class="rata">
                <div class="text-center">
                  <template v-if="k == 'Gas'">
                    <i class="icon icon-white mb-1 sgri-gas"></i>
                    <div class="small-text-azure text-white">Gas</div>
                  </template>
                  <template v-else-if="k == 'Electricity'">
                    <i class="icon icon-white mb-1 sgri-luce"></i>
                    <div class="small-text-azure text-white">Luce</div>
                  </template>
                </div>
                <div>
                  <div class="big-text-yallow">{{ r.Amount }} €</div>
                  <div class="h4-regular-white">al mese, per 12 mesi!</div>
                </div>
              </div>
            </div>

        </b-col>

        <b-col lg="5" offset-lg="1" class="text-center lg:text-right">
          <b-button block variant="primary" class="mb-2 text-uppercase"
                    :to="{name:'attiva-offerta',params:{utilityType:realUtilityType}}">ATTIVA {{ packName }}
          </b-button>
          <b-button v-if="buttonStima" block variant="primary" class="btn-outline text-uppercase"
                    :to="{name:'invia-stima',params:{utilityType:realUtilityType}}">INVIAMI QUESTA STIMA
          </b-button>
        </b-col>
      </b-row>

    </b-container>

    <b-modal id="modal-relax"
             modal-class="modal-full"
             header-class="container"
             body-class="container"
             scrollable :hide-footer="true" v-if="modal">
      <div slot="modal-header-close">
        <img src="@/assets/icons/exit.svg">
      </div>

      <b-row align-h="center" class="mb-4">
        <b-col lg="8">
          <h2 class="h3-semibold-black mb-2" v-html="modal.title"></h2>
          <p class="p-medium-gray-600 mb-4" v-html="modal.description"></p>
        </b-col>
      </b-row>

    </b-modal>

  </div>
</template>

<script>

import Vue from "vue";

export default {
  name: 'StepRata',
  components: {},
  data() {
    return {
      modalCode: "0003",
      modal: null,
      localOptions: null,
      webPath: process.env.VUE_APP_WEB_PATH,
      rate: {},
      connections: null,
      realUtilityType: null,
      buttonStima: true
    }
  },
  props: {
    options: {
      type: [Array, Object],
      required: true
    }
  },
  computed: {
    packName() {
      let name = '';
      switch (this.realUtilityType) {
        case 'Gas':
          name = 'Serena Gas';
          break;
        case 'Electricity':
          name = 'Serena Luce';
          break;
        case 'Dual':
          name = 'Serena';
          break;
      }
      return name;
    },
  },
  created() {
    this.$root.footer = false;
    this.localOptions = this._.cloneDeep(this.options);

    if (
        (typeof this.$route.query.cl !== 'undefined' && typeof this.$route.query.al !== 'undefined')
        || (typeof this.$route.query.cg !== 'undefined' && typeof this.$route.query.ag !== 'undefined')
    ) {

      let that = this;
      that.$root.loading = true;
      let params = {};
      params['action'] = 'relax_get_rata';
      params['k'] = this.$route.query.k;
      that.axios.get(that.webPath + 'wp-admin/admin-ajax.php', {params: params})
          .then((response) => {
            let data = that.decryptAES(response.data);
            if ((typeof data.error !== 'undefined' && data.error) || !data.success) {
              that.showAlertModal(data.message).then(() => {
                if (typeof data.redirecthome !== 'undefined' && data.redirecthome)
                {
                  window.location.href = "https://www.sgrlucegas.com";
                }
                else
                {
                  that.goToBack()
                }
              })
            } else if (data.success) {
              if (typeof this.$route.query.cl !== 'undefined' && atob(this.$route.query.cl) > 0 && typeof this.$route.query.al !== 'undefined') {
                let electricity = {
                  Consumption: atob(this.$route.query.cl),
                  Amount: atob(this.$route.query.al),
                  Power: atob(this.$route.query.pl),
                  Resident: atob(this.$route.query.rl)
                }

                if (electricity.Consumption > 0 && electricity.Amount > 0) {
                  Vue.set(this.rate, 'Electricity', electricity)
                  this.realUtilityType = 'Electricity';
                }
              }
              if (typeof this.$route.query.cg !== 'undefined' && atob(this.$route.query.cg) > 0 && typeof atob(this.$route.query.ag) !== 'undefined') {
                let gas = {
                  Consumption: atob(this.$route.query.cg),
                  Amount: atob(this.$route.query.ag),
                }

                if (gas.Consumption > 0 && gas.Amount > 0) {
                  Vue.set(this.rate, 'Gas', gas)
                  this.realUtilityType = this.realUtilityType == null ? 'Gas' : 'Dual';
                }
              }
              Vue.set(this.localOptions, 'rate', this.rate)
              Vue.set(this.localOptions, 'comune', {})
              Vue.set(this.localOptions.comune, 'istat', atob(this.$route.query.is))
              Vue.set(this.localOptions, 'seiCliente', atob(this.$route.query.co));

              if(this.$route.query.cf !== 'undefined' && this.$route.query.cn !== 'undefined')
              {
                let cliente = {
                    FiscalCode : atob(this.$route.query.cf),
                    ContractNumber : atob(this.$route.query.cn)
                }
                Vue.set(this.localOptions, 'cliente', cliente);
              }

              this.$emit('updateOptions', this.localOptions);

              this.buttonStima = false;
            }
            that.$root.loading = false;
          })
          .catch((error) => {
            this.captureExceptionSentry(error);
            let message = 'Qualcosa è andato storto, ti invitiamo a riprovare.'
            that.showAlertModal(message).then(() => {
              that.goToBack()
            })
            return false;
          })
    } else {
      this.connections = this.localOptions.forniture.Connections;
      if (this.connections.length > 1) this.realUtilityType = 'Dual'
      else this.realUtilityType = this.localOptions.consumo[0].UtilityType;

      this.getRate();
    }

    if(typeof window.fbq != 'undefined') {
      this.trackFbViewContent('configuratore_serena', 'step-rate');
    }

    this.getModal(this.modalCode);

  },
  mounted() {
  },
  methods: {

    async getRate() {
      let that = this;
      let istat = that.localOptions.comune.istat;
      let consumi = that.localOptions.consumo;
      let params = {};
      for(const consumo of consumi){
        let c = null;
        switch (consumo.UtilityType) {
          case 'Electricity':
            c = this.connections.find(item => item.UtilityType == 'EE');
            params = {
              UtilityType: consumo.UtilityType,
              ISTATCode: istat,
              PowerCommitted: c.PotenzaImpegnata,
              Residential: c.Residential,
              Consumption: consumo.Consumption,
            }
            break;
          case 'Gas':
            params = {
              UtilityType: consumo.UtilityType,
              ISTATCode: istat,
              Consumption: consumo.Consumption,
            }
            break;
        }
        await that.getRata(params);
      }

      that.localOptions.rate = that.rate;
      that.$emit('updateOptions', that.localOptions);
    },

    getRata(params) {
      let that = this;
      that.$root.loading = true;
      params['action'] = 'relax_get_rata'
      return that.axios.get(that.webPath + 'wp-admin/admin-ajax.php', {params: params})
          .then((response) => {
            let data = that.decryptAES(response.data);
            if ((typeof data.error !== 'undefined' && data.error) || !data.success) {
              let noRetry = false;
              if(typeof data.error === 'undefined' && !data.success && typeof data.redirecthome !== 'undefined') noRetry = true;
              that.showAlertModal(data.message, noRetry).then(() => {
                that.goToBack();
              })
            } else if (data.success) {
              Vue.set(that.rate, params.UtilityType, data.data)
            }
            that.$root.loading = false;
            return true;
          })
          .catch((error) => {
            this.captureExceptionSentry(error);
            let message = 'Qualcosa è andato storto, ti invitiamo a riprovare.'
            that.showAlertModal(message).then(() => {
              that.goToBack()
            })
            return false;
          })
    },

    goToBack() {
      this.$router.push({name: 'step-si-consumo'})
    },
    getModal(id) {
      let that = this;
      that.axios.get(that.webPath + 'wp-admin/admin-ajax.php', {
        params: {
          action: 'modal_relax',
        }
      })
          .then(response => {
            let modals = response.data.modal;
            that.modal = modals.find(m => m.id == id);
          })
          .catch((error) => {
            this.captureExceptionSentry(error);
            return false;
          })
    },
  },
}
</script>

<style scoped lang="scss">
</style>